import React from 'react';
import PropTypes from 'prop-types';

const TabPanel = ({ ...props }) => {
  const { children, value, index } = props;
  return (
    <div role="tabPanel" hidden={value !== index}>
      {value === index && <React.Fragment>{children}</React.Fragment>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.any.isRequired,
  index: PropTypes.any.isRequired,
};

export default TabPanel;
